import { SCENE_DURATION, TOTAL_SCENES } from "../../constants/sceneConfig";
import { skyboxCommon } from "./common";
import { scenePlasma } from "./scenes/plasma";
import { sceneTunnel } from "./scenes/tunnel";
import { sceneSpheres } from "./scenes/spheres";
import { sceneStars } from "./scenes/stars";
import { sceneMoire } from "./scenes/moire";
import { sceneGrid } from "./scenes/grid";
import { sceneGem } from "./scenes/gem";
import { sceneBars } from "./scenes/bars";
import { sceneVoxels } from "./scenes/voxels";
import { sceneAurora } from "./scenes/aurora";
import { sceneSelector } from "./sceneSelector";

const vertexShader = `
    varying vec3 vDir;
    void main() {
      vDir = position; 
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;

const fragmentShader = `
${skyboxCommon}
${scenePlasma}
${sceneTunnel}
${sceneSpheres}
${sceneStars}
${sceneMoire}
${sceneGrid}
${sceneGem}
${sceneBars}
${sceneVoxels}
${sceneAurora}
${sceneSelector}

    void main() {
        vec3 rd = normalize(vDir); 
        vec2 uv = vec2(atan(rd.z, rd.x)/6.28, acos(rd.y)/3.14); 
        
        float duration = ${SCENE_DURATION.toFixed(1)};
        float totalScenes = ${TOTAL_SCENES.toFixed(1)};
        float idx = floor(mod(time/duration, totalScenes));
        float nextIdx = floor(mod((time/duration)+1., totalScenes));
        float tVals = smoothstep(0., 1., (mod(time,duration)-(duration-1.)));

        vec3 c = sampleScene(idx, rd, uv, time);
        vec3 nc = sampleScene(nextIdx, rd, uv, time);
        if(tVals>0.) { c=mix(c,nc,tVals); c+=vec3(sin(tVals*PI)*.8); }
        float vis = sin(rd.x*100.)*sin(rd.y*100.+time*5.);
        c *= vec3(vis*.05+.95);
        gl_FragColor = vec4(c, 1.);
    }
`;

export const DemoShaderMaterial = {
  uniforms: { time: { value: 0.0 } },
  vertexShader,
  fragmentShader,
};
